export default __webpack_public_path__ + "static/media/size-min.c8434037.svg";